<!-- to be used in single reports to group information -->
<template>
  <v-row class="grey lighten-1 content-4">
    <v-col class="col-6">
      {{ title }}
    </v-col>

    <!-- total amount of people -->
    <v-col v-if="rightTitle" class="col-6 text-right">
      <span v-html="rightTitle" />
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'SingleReportGroupByHeader',

  props: {
    title: {
      type: String,
      required: true,
    },

    rightTitle: {
      type: String,
      required: false,
      default: null,
    },
  },
}
</script>
